import React from 'react';
import { ts } from 'src/utils/translate';
import { PlannerSvg } from './PlannerSvg';
import { Legend } from './Legend';

export const WifiMap = (props: { enabled: boolean; floorWifiSvgObject: any }) => {
  const { enabled, floorWifiSvgObject } = props;

  return (
    <div
      className="map-comp-root wifi-map-comp"
      style={enabled ? undefined : { display: "none" }}
      data-wififloorid={floorWifiSvgObject.floorId}
    >
      <h3 className="floorcont-pre ">
        {ts("q_wificoverage", "Wi-Fi Coverage")} ({floorWifiSvgObject.wifiType})
      </h3>
      <div
        style={{ position: "relative", textAlign: "center" }}
        className="map-center-align"
      >
        {floorWifiSvgObject.plannerSVG &&
        floorWifiSvgObject.plannerSVG.length > 0 ? (
          <PlannerSvg floorWifiSvgObject={floorWifiSvgObject} />
        ) : null}

        {floorWifiSvgObject.legend && floorWifiSvgObject.legend.length > 0 ? (
          <Legend floorWifiSvgObject={floorWifiSvgObject} />
        ) : null}
      </div>
    </div>
  );
};